var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNzm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n        fill: black;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20010-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4496",
    className: "cls-1",
    d: "M6.2,8.9c1.7.4,3.4,1.2,4.8,2.4,1.3,1.1,1.7,2.7.3,3.8,0-.1-.2-.4-.4-.9h0c-.2-.4-.5-.8-.8-1.3l.3-1.6c0-.1,0-.2-.2-.3-.1,0-.2,0-.3.2l-.2,1.2c-.4-.6-.9-1.1-1.4-1.7,0,0-.2-.1-.3,0s-.1.2,0,.3c0,0,0,0,0,0,.6.6,1.1,1.3,1.6,2,0,0,0,0,0,0,.2.3.4.6.5.9l-1.5-.5c-.1,0-.2,0-.3.1s0,.2.1.3c0,0,0,0,0,0l1.9.6c.3.5.4.8.4.8,0,0,0,0,0,0-.5.3-1.1.5-1.7.5-1.7-.1-2-2.1-2.2-3.5,0-1.2-.3-2.3-.8-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4497",
    className: "cls-1",
    d: "M15.8,6.2c-1.3.3-2.5.8-3.5,1.6-.9.8-1.3,1.9-.3,2.8,0,0,.2-.3.3-.6h0c.2-.3.4-.6.6-.9l-.2-1.2c0,0,0-.2.1-.2,0,0,.2,0,.2.1v.9c.4-.4.8-.8,1.2-1.2,0,0,.2,0,.2,0,0,0,0,.2,0,.2h0c-.4.4-.9.9-1.2,1.4h0c-.2.2-.3.4-.4.6l1.1-.3c0,0,.2,0,.2.1s0,.2-.1.2h0l-1.4.4c-.2.4-.3.6-.3.6,0,0,0,0,0,0,.4.2.8.4,1.2.4,1.3,0,1.5-1.5,1.7-2.5,0-.8.3-1.7.6-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4498",
    className: "cls-1",
    d: "M21,15.5c-2.5,5.6-9,8.1-14.5,5.6C1,18.6-1.5,12.1.9,6.6c.3-.6.6-1.3,1-1.8l2.3,1.7c-2.5,3.7-1.5,8.8,2.2,11.3,3.7,2.5,8.8,1.5,11.3-2.2.2-.4.5-.8.6-1.2l2.6,1.1ZM13.4.3c5.9,1.3,9.7,7.2,8.4,13.1,0,0,0,0,0,0l-2.7-1.2c.7-4.3-2.2-8.4-6.5-9.2l.9-2.7ZM11,0h.1l-.9,2.9c-1.7.2-3.3.8-4.5,1.9l-2.3-1.8C5.4,1.1,8.2,0,11,0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzm);
export default __webpack_public_path__ + "static/media/NZM.d15088d070e8fda185a828eb1ca9e2f8.svg";
export { ForwardRef as ReactComponent };